import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { RiArrowDownSLine } from "react-icons/ri";
import logo from "../assets/colored logo.png";

export default function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;
  const isAboutActive = () =>
    ["/about", "/team", "/testinomials"].includes(location.pathname);

  const handleDropdownLinkClick = () => {
    setDropdownOpen(false);
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="logo here" />
        <span>Codeonet Technologies</span>
      </div>
      <div className="header-right">
        <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <Link to="/" className={isActive("/") ? "active-link" : ""}>
            HOME
          </Link>
          <div
            className={`dropdown ${
              isAboutActive() || dropdownOpen ? "open" : ""
            }`}
          >
            <div className="drop-container">
              <Link
                to="/about"
                className={`dropbtn ${isAboutActive() ? "active-link" : ""}`}
              >
                ABOUT
              </Link>
              <span
                className="arrow-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                <RiArrowDownSLine className="dwn-arrow" />
              </span>
            </div>
            {dropdownOpen && (
              <div className="dropdown-content">
                <Link to="/team" onClick={handleDropdownLinkClick}>
                  Team
                </Link>
                <Link to="/testinomials" onClick={handleDropdownLinkClick}>
                  Testimonials
                </Link>
              </div>
            )}
          </div>

          <Link
            to="/service"
            className={isActive("/service") ? "active-link" : ""}
          >
            SERVICES
          </Link>
          <Link
            to="/contact"
            className={isActive("/contact") ? "active-link" : ""}
          >
            CONTACT
          </Link>
        </nav>

        <div className="social-icons">
          <a href="#">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="#">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="#">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>

        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
}
